const ViewForeignApply = () => import('../modules/xmsb/energy/operators/ViewForeignApplyGzl')

export default [
  {

    path: '/foreignapplyview',
    name: 'foreignapplyview',
    component: ViewForeignApply,
    meta: {
      title: '鼓励企业境外投资',
      fullscreen: true,
    },
  },
]
